module.exports = __webpack_public_path__ + "img/change-blue.1bb8084c.svg";